import {KpiCalculationError} from '@hconnect/common/types'

export const EXPERT_SYSTEM_WIDGET_NAMESPACE = 'widget.expert-system'
export const VALIDATION_TRANSLATIONS_KEY: Record<KpiCalculationError, string> = {
  [KpiCalculationError.EmptyKpiValue]: 'expertSystemUtilization.error.notApplicable',
  [KpiCalculationError.EquipmentNotRunning]: 'expertSystemUtilization.error.stopped',
  [KpiCalculationError.NoKpiValue]: 'expertSystemUtilization.error.notApplicable',
  [KpiCalculationError.AmbiguousKpiValues]: 'expertSystemUtilization.error.notApplicable',
  [KpiCalculationError.UnrecognizedControlString]: 'expertSystemUtilization.error.notApplicable',
  [KpiCalculationError.InvalidNumericValue]: 'expertSystemUtilization.error.notApplicable'
}
